
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/codebuild/output/src1760905442/src/and-dine-hub/sentry.client.config.ts")
            }
          });